//  Date Filter
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const RESET_DATE = 'RESET_DATE';

// Occupancy
export const UPDATE_OCCUPANCY_REQUEST= 'UPDATE_OCCUPANCY_REQUEST';
export const UPDATE_OCCUPANCY_SUCCESS= 'UPDATE_OCCUPANCY_SUCCESS';
export const UPDATE_OCCUPANCY_FAIL= 'UPDATE_OCCUPANCY_FAIL';